// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"N1-z"};